import React from 'react'

interface Props {
  label: string
  value: number | null
  onChange: (value: number | null) => void
}

export const ProjectNullableNumberAttribute = ({ label, value, onChange }: Props) => {
  const val = value === null ? "" : String(value)
  return <div>
    <div className='label'>
      {label}
    </div>
    <div className='value'>
      <input
        type="number"
        value={val}
        onChange={e => {
          const val = e.target.value
          if (val === '') {
            onChange(null)
          } else {
            const num = Number(val)
            onChange(Number(num.toFixed(2)))
          }
        }}
      />
    </div>
  </div>
}
